import { camelCase, snakeCase } from "change-case";

const isUUID = (key: string) =>
  /^[0-9a-f]{8}-[0-9a-f]{4}-[0-9a-f]{4}-[0-9a-f]{4}-[0-9a-f]{12}$/i.test(key);

export const convertKeysToCamelCase = <T>(obj: T): T => {
  if (Array.isArray(obj)) {
    return obj.map((item) => convertKeysToCamelCase(item)) as T;
  }

  if (obj !== null && typeof obj === "object") {
    // biome-ignore lint: explicit any
    return Object.entries(obj).reduce((acc: any, [key, value]) => {
      const newKey = isUUID(key)
        ? key
        : camelCase(key, {
            prefixCharacters: "_",
          });
      acc[newKey] = convertKeysToCamelCase(value);
      return acc;
    }, {});
  }

  return obj;
};

export const convertKeysToSnakeCase = <T>(obj: T): T => {
  if (Array.isArray(obj)) {
    return obj.map((item) => convertKeysToSnakeCase(item)) as T;
  }

  if (obj !== null && typeof obj === "object") {
    // biome-ignore lint: explicit any
    return Object.entries(obj).reduce((acc: any, [key, value]) => {
      const newKey = isUUID(key) ? key : snakeCase(key);
      acc[newKey] = convertKeysToSnakeCase(value);
      return acc;
    }, {});
  }

  return obj;
};
